import axios from '../../localAxios';
import { moveWorkspaceFoldersURL } from '../workspacesURLs';

interface MoveWorkspaceFoldersParams {
  workspaceId: string;
  workspaceFolderIds: string[];
  parentFolderId?: string;
}

export async function moveWorkspaceFolders({
  workspaceId,
  workspaceFolderIds,
  parentFolderId = null,
}: MoveWorkspaceFoldersParams) {
  if (workspaceFolderIds.length < 1) {
    return;
  }
  const url = await moveWorkspaceFoldersURL(workspaceId);
  const response = await axios.put(url.href, {
    parent_id: parentFolderId,
    workspace_folder_ids: workspaceFolderIds,
  });

  return response.data;
}
